import { render } from "./SquareButton.vue?vue&type=template&id=497d8a3a"
const script = {}

import "./SquareButton.vue?vue&type=style&index=0&id=497d8a3a&lang=scss"

import exportComponent from "/media/shared/vue/imgcropper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__